import * as React from "react"
import styled from "styled-components"
import { GatsbyImage } from "gatsby-plugin-image"
import { Link } from "gatsby"

export const Post = ({ title, date, author, excerpt, slug, img }) => {
  return (
    <Card to={`/${slug}`}>
      {img ? <Cover image={img} alt={title} /> : null}
      <Body>
        <Meta>
          {date} · {author}
        </Meta>
        <Title>{title}</Title>
        <Excerpt>{excerpt}</Excerpt>
        <More>Läs mer</More>
      </Body>
    </Card>
  )
}

const Card = styled(Link)`
  display: block;
  overflow: hidden;
  border: 1px solid var(--border);
  border-radius: 1.75rem;
  background: var(--elevated);
  text-decoration: none;
  color: inherit;
  margin: 0 0 1.5rem;
`

const Cover = styled(GatsbyImage)`
  display: block;
  aspect-ratio: 16 / 9;
  width: 100%;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`

const Body = styled.div`
  padding: 1.35rem 1.35rem 1.5rem;
`

const Meta = styled.p`
  font-size: 0.8125rem;
  color: var(--muted);
`

const Title = styled.h2`
  margin-top: 0.5rem;
  font-family: var(--font-serif);
  font-size: 1.5rem;
  font-weight: 600;
  letter-spacing: -0.03em;
  line-height: 1.25;
`

const Excerpt = styled.p`
  margin-top: 0.75rem;
  color: var(--muted);
  font-size: 0.975rem;
  line-height: 1.6;
  max-width: 65ch;
`

const More = styled.span`
  display: inline-block;
  margin-top: 1rem;
  font-size: 0.875rem;
  color: var(--accent);
`
